const config = {
  keys: {
    announcement: "announcement",
    klaviyoId: "MEEw2K",
    recently_viewed: "recently_viewed",
  },
  attributes: {
    isGwp: "isGWP",
  },
  reactify: {
    includeFields: ["storefrontId", "presentment_price_ranges", "images", "tags", "variants.*"],
    excludeFields: ["image"],
  },
  functions: {
    updateCustomer: "https://australia-southeast1-stunning-hull-385405.cloudfunctions.net/customerDetails",
  },
  stores: {
    "industrie-clothing": {
      shopify_domain: "industrie-clothing",
      storefront_access_token: "d5afa317029281c915389552746e498b",
      url: "https://www.industrie.com.au",
      region: "AU",
      klaviyoId: "MEEw2K",
      klaviyoList: "TCBs4K", //Open email L3D
    },
    "industrie-australia": {
      shopify_domain: "industrie-australia",
      storefront_access_token: "fd4e5deb1674117fb9c674f4fa35df3b",
      url: "https://industrieaustralia.com",
      region: "US",
      klaviyoId: "UNqNnq",
      klaviyoList: "TwaNye", // US Active
    },
    "industrie-kids": {
      shopify_domain: "industrie-kids",
      storefront_access_token: "79dcd1c72f2cbd3c738d713c65050801",
      url: "https://www.industriekids.com.au",
      region: "AU",
      klaviyoId: "P64qyX",
      klaviyoList: "YuBCQ7", //Active L60D - All
    },
    "industrie-new-staging": {
      shopify_domain: "industrie-new-staging",
      storefront_access_token: "6bb9314f50fe1657c0e21074210bc4e9",
      url: "https://industrie-new-staging.myshopify.com",
      region: "AU",
      klaviyoId: "SfhffU",
      klaviyoList: "MEEw2K",
    },
    "industrie-clothing-us-staging": {
      shopify_domain: "industrie-clothing-us-staging",
      storefront_access_token: "a989f7edd8756fa49fc5e72fb3b0c0b3",
      url: "https://industrie-clothing-us-staging.myshopify.com",
      region: "US",
      klaviyoId: "MEEw2K",
      klaviyoList: "MEEw2K",
    },
    "industrie-kids-staging": {
      shopify_domain: "industrie-kids-staging",
      storefront_access_token: "c4c211d83670c314be7baf5f553febb1",
      url: "https://industrie-kids-staging.myshopify.com",
      region: "AU",
      klaviyoId: "MEEw2K",
      klaviyoList: "MEEw2K",
    },
  },
};

export type Config = ReturnType<typeof config>;

export default config;
